import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {LlmConfig} from '../../../../store/models/DuplicateCheck';

const useStyles = makeStyles(() => ({
    select: {
        minWidth: 200,
    },
}));

interface LlmPanelProps {
    config: LlmConfig | null;
    preset: string | undefined;
    onPresetChange: (preset: string) => void;
}

export default function LlmPanel({config, preset, onPresetChange}: LlmPanelProps) {
    const classes = useStyles();
    const presets = config?.presets ?? [];

    return (
        <FormControl size="small" className={classes.select} disabled={presets.length === 0}>
            <InputLabel id="llm-preset-label">LLM-Modell</InputLabel>
            <Select
                labelId="llm-preset-label"
                value={preset ?? ''}
                onChange={(e) => onPresetChange(e.target.value as string)}
            >
                {presets.map((p) => (
                    <MenuItem key={p.name} value={p.name}>{p.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
